// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* conteneur englobant l'ensemble des informations */
table{
    border-collapse:collapse;
}
tr>td {
  padding: 5px;
}
table,
tr,
td,
div {
    page-break-inside: avoid;
}
.EtiquetteDemi{
	width: 5.7cm;
	height: 4cm;
}
.no-margin-print{margin-top: 20px;}
.no-margin-top-left{
	margin-top: 20px;
	margin-left: 25px;
}
.no-padding-print{
	padding-left: 90px !important;
}
.dlpro-manufacturer-name-custom{
	font-size: 10px;
    width: 100%;
}
.logoP2BouPromoDemiPromo {
    background-color: #e8182e;
    color: #fff;
    border-radius: 50px;
    font-size: 10px;
    font-weight: bold;
    width: 70%;
    text-align: center;
    margin: 0 auto;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.EtiquetteDemiSize{
	width: 5.7cm;
  height: 4cm;
}

.logoFabricantEtiquetteDemi {
         position: absolute;
    top: 5px;
    left: 50%;
    transform: translateX(-50%);
}
.logoFabricantEtiquetteDemi img {
    height: 20px;
}

.etiquetteDemiCheckGreen {
       position: absolute;
    top: 5px;
    left: 5px;
}
.etiquetteDemiCheckGreen img{
    width: 20px;
} 

.conteneurEtiquetteDemi {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: solid 0.1px;
  position: relative;
  width: 5.7cm;
  height: 4cm;
}

/* éléments contenus dans l'étiquette par ordre d'apparition de haut en bas */
.logoFabricantDemi {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logoFabricantDemi img {
  height: 30px;
  margin-top: 2px;
}

.logoFabricantDemi img + img {
  height: 20px;
    position: absolute;
    right: 0;
    top: 0;
}

.PVCDemi {
    color: black;
    margin-bottom: 10px;
    font-size: 10px;
    position: absolute;
    bottom: 37%;
    left: 0;
	
}

.logoP2BouPromoDemiPrixDebad{
	       display: flex;
    justify-content: end;
    align-items: end;
}
.logoP2BouPromoDemiPrixDebad span {
    font-size: 11px;
    margin-right: 2px;
    line-height: 13px;
}
.logoP2BouPromoDemiPrixDebad img{
	        width: 25%;
}

.PVCDemiPrice {
       color: black;
    font-size: 13px;
    position: absolute;
    bottom: 2px;
    left: 0;
    text-align: center;
    width: 100%;
}

.bigSizeDemiEtiquette {
  color: red;
    font-size: 10px;
    font-weight: 600;
    text-align: center;
    position: absolute;
    top: 35px;    line-height: 11px;
	    width: 90%;
}

.mediumSizeDemiEtiquette {
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  margin: 2px 0 2px 0;
}

.smallSizeDemiEtiquette {
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 7px;
  font-weight: 600;
  margin: 2px 0 2px 0;
}

.logoP2BouPromoDemi {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logoP2BouPromoDemi img {
  height: 20px;
}

.PVDemiIMG{
	  
		     display: block;    margin: 0 auto;
}

.PVDemi {
    position: absolute;
    color: var(--blue-color);
    font-size: 18px;
    font-weight: 600;
    bottom: 11%;
    right: 0;
    text-align: right;
}

.PVDemiPrice{
	     position: absolute;
    top: 38%;
    right: 10px;
    text-align: right;
    color: white;
    font-size: 18px;
}

.caracteristiquesProduitDemi {
  color: black;
    font-size: 10px;
    font-weight: 600;
    position: absolute;
    bottom: 1px;
}

@media print {
	.no-print{
		display: none !important;
	}
  table { page-break-after:auto }
  table tr    { page-break-inside:avoid; page-break-after:auto }
  table thead { display:table-header-group }
  table tfoot { display:table-footer-group }
  .page-break  { display: block; page-break-before: always; }
  .no-padding-print{ padding-left: 0 !important;}
  .no-margin-print{margin-top: 0;}
  .no-margin-top-left{ margin-top: 0; margin-left: 0;}
 }
 @media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/DemiEtiquette.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;IACI,wBAAwB;AAC5B;AACA;EACE,YAAY;AACd;AACA;;;;IAII,wBAAwB;AAC5B;AACA;CACC,YAAY;CACZ,WAAW;AACZ;AACA,iBAAiB,gBAAgB,CAAC;AAClC;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;IACZ,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;CACC,YAAY;EACX,WAAW;AACb;;AAEA;SACS,kBAAkB;IACvB,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;AACA;IACI,YAAY;AAChB;;AAEA;OACO,kBAAkB;IACrB,QAAQ;IACR,SAAS;AACb;AACA;IACI,WAAW;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;IACV,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,OAAO;;AAEX;;AAEA;QACQ,aAAa;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;SACS,UAAU;AACnB;;AAEA;OACO,YAAY;IACf,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,WAAW;AACf;;AAEA;EACE,UAAU;IACR,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS,KAAK,iBAAiB;KAC9B,UAAU;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;;OAEO,cAAc,KAAK,cAAc;AACxC;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,QAAQ;IACR,iBAAiB;AACrB;;AAEA;MACM,kBAAkB;IACpB,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;EACE,YAAY;IACV,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;CACC;EACC,wBAAwB;CACzB;EACC,QAAQ,sBAAsB;EAC9B,cAAc,uBAAuB,EAAE,sBAAsB;EAC7D,cAAc,2BAA2B;EACzC,cAAc,2BAA2B;EACzC,eAAe,cAAc,EAAE,yBAAyB,EAAE;EAC1D,mBAAmB,0BAA0B,CAAC;EAC9C,iBAAiB,aAAa,CAAC;EAC/B,qBAAqB,aAAa,EAAE,cAAc,CAAC;CACpD;CACA;EACC;CACD,WAAW;EACV;AACF","sourcesContent":["/* conteneur englobant l'ensemble des informations */\ntable{\n    border-collapse:collapse;\n}\ntr>td {\n  padding: 5px;\n}\ntable,\ntr,\ntd,\ndiv {\n    page-break-inside: avoid;\n}\n.EtiquetteDemi{\n\twidth: 5.7cm;\n\theight: 4cm;\n}\n.no-margin-print{margin-top: 20px;}\n.no-margin-top-left{\n\tmargin-top: 20px;\n\tmargin-left: 25px;\n}\n.no-padding-print{\n\tpadding-left: 90px !important;\n}\n.dlpro-manufacturer-name-custom{\n\tfont-size: 10px;\n    width: 100%;\n}\n.logoP2BouPromoDemiPromo {\n    background-color: #e8182e;\n    color: #fff;\n    border-radius: 50px;\n    font-size: 10px;\n    font-weight: bold;\n    width: 70%;\n    text-align: center;\n    margin: 0 auto;\n    height: 18px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.EtiquetteDemiSize{\n\twidth: 5.7cm;\n  height: 4cm;\n}\n\n.logoFabricantEtiquetteDemi {\n         position: absolute;\n    top: 5px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n.logoFabricantEtiquetteDemi img {\n    height: 20px;\n}\n\n.etiquetteDemiCheckGreen {\n       position: absolute;\n    top: 5px;\n    left: 5px;\n}\n.etiquetteDemiCheckGreen img{\n    width: 20px;\n} \n\n.conteneurEtiquetteDemi {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: solid 0.1px;\n  position: relative;\n  width: 5.7cm;\n  height: 4cm;\n}\n\n/* éléments contenus dans l'étiquette par ordre d'apparition de haut en bas */\n.logoFabricantDemi {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logoFabricantDemi img {\n  height: 30px;\n  margin-top: 2px;\n}\n\n.logoFabricantDemi img + img {\n  height: 20px;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n.PVCDemi {\n    color: black;\n    margin-bottom: 10px;\n    font-size: 10px;\n    position: absolute;\n    bottom: 37%;\n    left: 0;\n\t\n}\n\n.logoP2BouPromoDemiPrixDebad{\n\t       display: flex;\n    justify-content: end;\n    align-items: end;\n}\n.logoP2BouPromoDemiPrixDebad span {\n    font-size: 11px;\n    margin-right: 2px;\n    line-height: 13px;\n}\n.logoP2BouPromoDemiPrixDebad img{\n\t        width: 25%;\n}\n\n.PVCDemiPrice {\n       color: black;\n    font-size: 13px;\n    position: absolute;\n    bottom: 2px;\n    left: 0;\n    text-align: center;\n    width: 100%;\n}\n\n.bigSizeDemiEtiquette {\n  color: red;\n    font-size: 10px;\n    font-weight: 600;\n    text-align: center;\n    position: absolute;\n    top: 35px;    line-height: 11px;\n\t    width: 90%;\n}\n\n.mediumSizeDemiEtiquette {\n  color: black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  margin: 2px 0 2px 0;\n}\n\n.smallSizeDemiEtiquette {\n  color: black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 7px;\n  font-weight: 600;\n  margin: 2px 0 2px 0;\n}\n\n.logoP2BouPromoDemi {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logoP2BouPromoDemi img {\n  height: 20px;\n}\n\n.PVDemiIMG{\n\t  \n\t\t     display: block;    margin: 0 auto;\n}\n\n.PVDemi {\n    position: absolute;\n    color: var(--blue-color);\n    font-size: 18px;\n    font-weight: 600;\n    bottom: 11%;\n    right: 0;\n    text-align: right;\n}\n\n.PVDemiPrice{\n\t     position: absolute;\n    top: 38%;\n    right: 10px;\n    text-align: right;\n    color: white;\n    font-size: 18px;\n}\n\n.caracteristiquesProduitDemi {\n  color: black;\n    font-size: 10px;\n    font-weight: 600;\n    position: absolute;\n    bottom: 1px;\n}\n\n@media print {\n\t.no-print{\n\t\tdisplay: none !important;\n\t}\n  table { page-break-after:auto }\n  table tr    { page-break-inside:avoid; page-break-after:auto }\n  table thead { display:table-header-group }\n  table tfoot { display:table-footer-group }\n  .page-break  { display: block; page-break-before: always; }\n  .no-padding-print{ padding-left: 0 !important;}\n  .no-margin-print{margin-top: 0;}\n  .no-margin-top-left{ margin-top: 0; margin-left: 0;}\n }\n @media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
